'use strict';

var tslib = require('tslib');

function variant(name, Component, defaultProps) {
    if (defaultProps === void 0) { defaultProps = {}; }
    // "Clone" the function, to create a new, identical React component
    var Variant = Component.bind(undefined);
    Variant.defaultProps = tslib.__assign(tslib.__assign(tslib.__assign({}, Component.defaultProps), defaultProps), { variant: name.toLowerCase() });
    if (name) {
        Variant.displayName = name;
    }
    return Variant;
}
function classNames(componentName, props) {
    var additionalClassNames = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalClassNames[_i - 2] = arguments[_i];
    }
    return tslib.__spreadArray([
        componentName,
        props.variant && componentName + "--" + props.variant,
        props.className
    ], additionalClassNames, true).filter(Boolean)
        .join(' ');
}

exports.classNames = classNames;
exports.variant = variant;
//# sourceMappingURL=lib-26f8f706.js.map
